import { find } from 'lodash';
import { Record, List } from 'immutable';

import { IMAGE_STATUS } from 'commons-vehicle/ModelYear/constants/exteriorColourStatuses.js';
import PURCHASE_METHODS_VALUES from 'commons-vehicle/PurchaseMethods/constants/purchaseMethodsValues.js';
import PurchaseMethodsModel from 'commons-vehicle/PurchaseMethods/models/PurchaseMethodsModel.js';

const YearRecord = Record({
    year: 0,
    selected: false,
    make: '',
    model: '',
    bodyStyleCode: '',
    bodyStyle: '',
    modelTrimPurchaseMethodIds: [],
    isSingleConfiguration: false,
    hasOptions: true,
    exteriorColours: {
        photo1: '',
        photo2: '',
        photo3: '',
    },
    exteriorColourStatus: IMAGE_STATUS.NO_IMAGE,
    highRebate: 0,
    highRebatePurchaseMethod: PURCHASE_METHODS_VALUES.CASH,
    modelTrims: List([]),
    drivePowerTrains: List([]),
    optionsPackages: List([]),
    purchaseMethods: new PurchaseMethodsModel(),
});

class Year extends YearRecord {
    getModelTrimSelectedPurchaseMethodId(selectedPurchaseMethod) {
        return find(this.modelTrimPurchaseMethodIds, (modelTrimPurchaseMethodId) => {
            return modelTrimPurchaseMethodId.purchaseMethod === selectedPurchaseMethod;
        });
    }
}

export default Year;



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/ModelYear/models/YearModel.js